<script lang="ts">
  import { Button, CardBody, CardHeader, Col, Input, Label } from "sveltestrap";
  import { Location, Findjobs } from "../../../../utils/Constant/Constant";
  import {locationdata} from "../../../../Data/Miscellaneous/CardView"
  import Card from "../../../Core/Card.svelte";
  let open:boolean = true
  
</script>
<Col xl="12">
    <Card>
        <CardHeader>
          <h5 class="mb-0 p-0">
            <Button class="btn-link ps-0" on:click={()=>open = !open}>{Location}</Button>
          </h5>
        </CardHeader>
        <div class="collapse {open ? "show" : ""}">
          <CardBody class="animate-chk">
            <div class="location-checkbox">
              {#each locationdata as checkItem}
                  <Label class="d-block" for={checkItem.id}>
                      <Input class="checkbox_animated" id={checkItem.id} type="checkbox" /> {checkItem.name}
                      <span class="d-block">{checkItem.subname}</span>
                  </Label>
              {/each}
            </div>
            <Button color="primary" class="text-center btn-block">{Findjobs}</Button>
          </CardBody>
        </div>
    </Card>
</Col>
        